<template>
    <div>
        <!-- Title and Logo -->
        <HeaderCard />
        <!-- end Logo and Title -->

        <!-- Panel Start here -->
        <panel title="Form Surat Pemberitahuan" class="panel panel-dark">
            <div>
                <b-card>
                    <b-row>
                        <b-col>
                            <h5 class="my-0">
                                SURAT PEMBERITAHUAN
                            </h5>
                            <h5 class="my-0">
                                HASIL PENGELOLAAN KEKAYAAN DAERAH YANG
                                DIPISAHKAN
                            </h5>
                        </b-col>
                        <!-- <b-col>
                            <h5 class="float-right">
                                <i class="fa fa-info"></i> Step 1 - PENDATAAN
                            </h5>
                        </b-col> -->
                    </b-row>
                </b-card>
            </div>
            <div class="mb-0 pb-0">
                <form
                    @submit.prevent="helper.editMode ? update(helper.spt_id) : store()"
                    @keydown="form.onKeydown($event)"
                    autocomplete="off"
                >
                    <b-card>
                        <div class="form-group row m-3">
                            <label class="col-md-3 col-form-label">Rekening
                                <span class="text-danger">*</span>
                            </label>
                            <div class="col-md-9">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <v-select
                                            label="nama"
                                            :reduce="nama => nama"
                                            :options="KodeRekening.kode_rekening_6"
                                            :class="{
                                                'style-chooser': helper.errors.hasOwnProperty(
                                                    'ref_rek_6_id'
                                                )
                                            }"
                                            placeholder="-Pilih Kode Rekening-"
                                            v-model="helper.nama_rekening"
                                            @input="inputKodeRekening(helper.nama_rekening)">
                                        </v-select>
                                        <em v-if="helper.errors.hasOwnProperty(
                                                    'ref_rek_6_id'
                                                ) && helper.errors"
                                            class="form-text text-danger">
                                            {{ helper.errors.ref_rek_6_id[0] }}
                                        </em>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row m-3">
                            <label
                                class="col-md-3 col-form-label"
                                >Kode Rekening
                            </label>
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-sm-5">
                                        <input
                                            type="text"
                                            :class="{
                                                'form-control': true
                                            }"
                                            disabled
                                            v-model="helper.kode_rekening"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row m-3">
                            <label
                                class="col-md-3 col-form-label"
                                >Tahun Buku
                                <span class="text-danger">*</span>
                            </label>
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-sm-5">
                                        <v-select
                                            :options="tahunBerjalan"
                                            placeholder="-Pilih Tahun-"
                                            :class="{
                                                'style-chooser': helper.errors.hasOwnProperty(
                                                    'tahun'
                                                )
                                            }"
                                            v-model="form.tahun"
                                        >
                                        </v-select>
                                        <em
                                            v-if="
                                                helper.errors.hasOwnProperty(
                                                    'tahun'
                                                ) && helper.errors
                                            "
                                            class="form-text text-danger"
                                        >
                                            {{ helper.errors.tahun[0] }}
                                        </em>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pt-3">
                            <h5>PERHITUNGAN</h5>
                            <div>
                                <div class="form-group row m-3">
                                    <label class="col-md-3 col-form-label">
                                        Menyetor Berdasarkan
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-md-9">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <v-select
                                                    :options="[
                                                        'Hasil Rapat Umum Pemegang Saham (RUPS)',
                                                        'Deviden Interim',
                                                        'Hasil Perhitungan Sendiri'
                                                    ]"
                                                    placeholder="-Pilih-"
                                                    :class="{
                                                        'style-chooser': helper.errors.hasOwnProperty(
                                                            'metode_pelaporan'
                                                        )
                                                    }"
                                                    v-model="form.metode_pelaporan"
                                                >
                                                </v-select>
                                                <em
                                                    v-if="
                                                        helper.errors.hasOwnProperty(
                                                            'metode_pelaporan'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                >
                                                    {{
                                                        helper.errors
                                                            .metode_pelaporan[0]
                                                    }}
                                                </em>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-3 col-form-label"
                                        >Jumlah yang akan disetor (Rp.)
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <input
                                                    type="text"
                                                    :class="{
                                                        'form-control': true,
                                                        'is-invalid': helper.errors.hasOwnProperty(
                                                            'jumlah'
                                                        )
                                                    }"
                                                    placeholder="Masukkan Jumlah Setoran"
                                                    v-model="form.jumlah"
                                                />
                                                <em
                                                    v-if="
                                                        helper.errors.hasOwnProperty(
                                                            'jumlah'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                >
                                                    {{
                                                        helper.errors.jumlah[0]
                                                    }}
                                                </em>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-3 col-form-label"
                                        >Dokumen Perhitungan
                                        <span class="text-danger"
                                            >*</span
                                        ></label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <b-form-file
                                                    plain
                                                    v-model="form.dokumen"
                                                    @change="handleFile"
                                                ></b-form-file>
                                                <em
                                                    v-if="
                                                        helper.errors.hasOwnProperty(
                                                            'dokumen'
                                                        ) && helper.errors
                                                    "
                                                    class="form-text text-danger"
                                                >
                                                    {{
                                                        helper.errors.dokumen[0]
                                                    }}
                                                </em>
                                                <small class="text-muted"
                                                    >Dokumen perhitungan
                                                    berformat .pdf dan max 2
                                                    MB.</small
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row m-3">
                                    <label
                                        class="col-md-3 col-form-label"
                                        >Keterangan (Optional)</label
                                    >
                                    <div class="col-md-7">
                                        <div class="row">
                                            <div class="col-sm-10">
                                                <b-form-textarea
                                                    id="textarea-large"
                                                    size="lg"
                                                    placeholder="Masukkan Keterangan"
                                                    rows="6"
                                                    v-model="form.keterangan"
                                                ></b-form-textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
                    <b-card class="mb-0 pb-0">
                        <b-row>
                            <b-col>
                                <b-button
                                    type="submit"
                                    variant="primary"
                                >
                                    <span v-if="helper.isLoading">
                                        <b-spinner
                                            small
                                            variant="primary"
                                            label="Spinning"
                                        ></b-spinner>
                                    </span>
                                    <i class="fa fa-save" v-else></i> 
                                    <span class="px-2" v-if="helper.editMode">Simpan Perubahan</span>
                                    <span class="px-2" v-else>Simpan</span>
                                </b-button>
                            </b-col>
                            <b-col>
                                <b-button
                                    variant="success"
                                    class="float-right"
                                    :disabled="helper.disableButtonNext"
                                    @click="updateSelesai(helper.spt_id)"
                                >
                                    <i class="fa fa-print"></i>
                                    Selesai & Cetak
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </form>
            </div>
            <!-- Selesai button loader -->
            <b-modal
                v-model="helper.showLoader"
                id="modalLoader"
                hide-footer
                hide-header
                no-close-on-backdrop
                centered
                size="sm"
            >
                <div class="text-center text-primary">
                    <b-spinner
                        variant="primary"
                        label="Text Centered"
                    ></b-spinner>
                    <h5>Harap Menunggu...</h5>
                    <div>Data Anda Sedang Di Proses</div>
                </div>
            </b-modal>
        </panel>
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import HeaderCard from "@/components/header/HeaderCard.vue";
import { mapState } from "vuex";
import sptMixins from "@/helper/spt/spt.js";

export default {
    mixins: [sptMixins],
    components: {
        HeaderCard
    },
    data() {
        return {
            tahunBerjalan: [],
            form: new Form({
                tahun: "",
                metode_pelaporan: "",
                jumlah: "",
                ref_rek_6_id: "",
                npbu_id: "",
                dokumen: "",
                keterangan: ""
            }),
            npbu_id: JSON.parse(localStorage.getItem("user")).npbu_id,
            helper: {
                errors: [],
                nama_rekening: "",
                kode_rekening: "",
                disableButtonSave: false,
                disableButtonNext: true,
                showLoader: false,
                isLoading: false,
                spt_id: "",
                editMode: false
            }
        };
    },
    computed: {
        ...mapState(["KodeRekening"])
    },
    mounted() {
        this.tahunBuku();
        // vuex - call data ref rek 6
        this.$store.dispatch("KodeRekening/getRefRek6");
        if (this.$route.name == "NextSpt") {
            this.detailSpt(this.$route.params.id);
            // this.helper.disableButtonSave = true;
            this.helper.editMode = true
            this.helper.disableButtonNext = false;
        }
    },
    methods: {
        // handle file event
        handleFile(event) {
            const file = event.target.files[0];
            this.form.dokumen = file;
        },
        // get 3 tahun buku
        tahunBuku() {
            const now = new Date();
            let tahun = now.getFullYear();
            // console.log(tahun);
            this.tahunBerjalan = [];
            for (let jumlahTahun = 2; jumlahTahun >= 0; jumlahTahun--) {
                this.tahunBerjalan.push(tahun - jumlahTahun);
            }
            // console.log(this.tahunBerjalan);
        },
        // ketika kode rekening dipilih
        inputKodeRekening(data) {
            if (data) {
                this.helper.kode_rekening = data.kode;
                this.form.ref_rek_6_id = data.ref_rek_6[0].id;
            } else {
                this.helper.kode_rekening = "";
                this.form.ref_rek_6_id = "";
            }
        }
    }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    border-color: red;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #394066;
}
</style>
